export const replaceString = (str: string, subString: string, value: string): string => {
  const regex = new RegExp('\\.' + subString, 'gi');
  return str.replace(regex, `.${value}`);
};
